// The DriveCars wordmark.
//
// Deliberately identical to apps/crew/src/components/Brand.tsx — same asset,
// same markup, same accessibility treatment. The admin previously drew a
// hand-rolled "DC" text badge instead, which is not the logo and matched
// nothing else we ship.
//
// Per the brand conventions: a plain <img> (no optimisation hop) paired with
// visually-hidden text, so screen readers and search engines get the name even
// though the logo carries it visually.
//
// The asset is apps/backoffice/public/brand/logo.jpg — the same 800x434 file
// the storefront and the crew app ship, copied rather than imported because
// Vite serves this app's own public/ directory.

export function BrandMark({ label = 'Admin' }: { label?: string }) {
  return (
    <span className="flex items-center gap-2">
      <img
        src="/brand/logo.jpg"
        alt=""
        aria-hidden="true"
        className="h-6 w-auto"
        width={800}
        height={434}
      />
      <span className="sr-only">DriveCars</span>
      {label ? (
        <span aria-hidden="true" className="text-sm font-semibold">
          {label}
        </span>
      ) : null}
    </span>
  );
}

/**
 * The square mark, for rails too narrow for the wordmark.
 *
 * The collapsed sidebar is 64px wide and the mobile header is no roomier; a
 * squashed wordmark reads worse there than the monogram it reduces to. Same
 * file the browser tab uses, so the two never disagree.
 */
export function BrandGlyph({ size = 28 }: { size?: number }) {
  return (
    <span className="inline-flex items-center">
      <img
        src="/brand/favicon.png"
        alt=""
        aria-hidden="true"
        width={size}
        height={size}
        style={{ width: size, height: size }}
      />
      <span className="sr-only">DriveCars</span>
    </span>
  );
}
